import { Route, Switch, useHistory } from 'react-router-dom';
import React, { useEffect } from 'react';
import PrivateRoute from './PrivateRoute';
import routerConfig from './routerConfig';
import ErrorFallback from './components/common/ErrorFallback';
import * as Sentry from '@sentry/react';
import CanonicalSlugRedirect from './components/routing/CanonicalSlugRedirect';

const SentryRoute = Sentry.withSentryRouting(Route);
const SentryPrivateRoute = Sentry.withSentryRouting(PrivateRoute);

const errorHandler = (error, info) => {
  console.error(error);
  console.log(info);
};

const HashChangeSync = () => {
  const history = useHistory();

  useEffect(() => {
    const handleHashChange = () => {
      const { pathname, search, hash } = window.location;
      if (
        history.location.pathname === pathname &&
        history.location.search === search &&
        history.location.hash !== hash
      ) {
        history.replace({ ...history.location, hash });
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [history]);

  return null;
};

export default function RouterMap() {
  return (
    <>
      <HashChangeSync />
      <Sentry.ErrorBoundary fallback={ErrorFallback} onError={errorHandler} onReset={() => { }}>
        <CanonicalSlugRedirect>
        <Switch>
          {routerConfig.map((route, i) =>
            route.private ? (
              <SentryPrivateRoute
                key={i}
                path={route.path}
                exact
                layout={route.layout}
                component={route.component}
                redirect={route.redirect}
              />
            ) : (
              <SentryRoute
                key={i}
                path={route.path}
                exact
                render={(props) =>
                  route.layout ? (
                    <route.layout {...props}>
                      <route.component {...Object.assign({}, props)} />
                    </route.layout>
                  ) : (
                    <route.component {...Object.assign({}, props)} />
                  )
                }
              />
            )
          )}
        </Switch>
        </CanonicalSlugRedirect>
      </Sentry.ErrorBoundary>
    </>
  );
}
